<template>
  <div v-if="computedCourseProfile">
    <FullCourseView
      :datapoints="courseProfileDatapoints"
      :course="computedCourseProfile"
      :centerCoords="marker"
      :directionsURL="createMapUrl"
      :wishlist-course-ids="wishlistCourseIds"
      @toggle-wishlist="toggleWishlist"
      :course-played-course-ids="coursePlayedCourseIds"
      @toggle-course-played="toggleCoursePlayed"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import FullCourseView from "@/components/FullCourseView.vue";
export default {
  name: "CourseProfile",
  components: {
    FullCourseView,
  },
  props: {
    courseId: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      map_url: "",
    };
  },
  mounted() {},
  watch: {
    computedCourseProfile() {
      // TODO: do we need this?
      // document.title = this.computedCourseProfile.course;
    },
  },
  methods: {
    ...mapActions(["updateWishlist", "updateCoursePlayed"]),
    toggleWishlist(id) {
      this.$store.dispatch("updateWishlist", id);
    },
    toggleCoursePlayed(id) {
      this.updateCoursePlayed(id);
    },
  },
  computed: {
    ...mapState(["courseMetadata"]),
    ...mapGetters([
      "courses",
      "courseProfileDatapoints",
      "wishlistCourseIds",
      "coursePlayedCourseIds",
    ]),
    computedCourseProfile() {
      var foundCourse = this.courses.find(
        course => course.id === this.courseId,
      );
      return foundCourse;
    },
    marker() {
      if (!this.computedCourseProfile) {
        return {};
      }
      let latLng = {
        lat: parseFloat(this.computedCourseProfile.latitude),
        lng: parseFloat(this.computedCourseProfile.longitude),
      };
      return latLng;
    },
    createMapUrl() {
      if (!this.computedCourseProfile) {
        return "";
      }
      let searchParams = new URLSearchParams();
      searchParams.append("api", 1);
      searchParams.append("destination", this.computedCourseProfile.OLGDP021);
      searchParams.append("travelmode", "driving");
      let fullParamString = searchParams.toString();
      const mapUrl = new URL(
        `https://www.google.com/maps/dir/?${fullParamString}`,
      );

      return mapUrl.href;
    },
  },
};
</script>
